import { render, staticRenderFns } from "./haiyaNews.vue?vue&type=template&id=25de947c&scoped=true&"
import script from "./haiyaNews.vue?vue&type=script&lang=js&"
export * from "./haiyaNews.vue?vue&type=script&lang=js&"
import style0 from "./haiyaNews.vue?vue&type=style&index=0&id=25de947c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25de947c",
  null
  
)

export default component.exports